module.exports = __webpack_public_path__ + "static/media/arrow.545de504.svg";